import { GzSelectableTableRowGroupWebComponent } from './component/GzSelectableTableRowGroupWebComponent';

export { GzSelectableTableRowGroupWebComponent };
